import { useState } from 'react';
import { SupportIcon } from '../assets/svgImages';

const getTopClass = (isImpersonating: boolean, hideBanner: boolean): string => {
  if (isImpersonating && hideBanner) return 'top-52';
  if (isImpersonating && !hideBanner) return 'top-72';
  if (!isImpersonating && hideBanner) return 'top-40';
  return 'top-52';
};

export default function ContactModal(props: any) {
  const [open, setOpen] = useState(false);

  const isImpersonating = Boolean(localStorage.getItem('impersonateUser'));
  const topClass = getTopClass(isImpersonating, props.hideBanner);

  const handleCall = () => {
    window.location.href = 'tel:1800123687';
  };

  const handleEmail = () => {
    window.location.href = '/contact-us';
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Support"
        className={`bg-primary-blue-500 text-white text-base font-semibold pl-4 pr-2 
        rounded-l-full py-3 fixed right-0 flex items-center 2.5xl:mt-5 z-[99] appearance-none border-none
        ${topClass}`}
      >
        <SupportIcon className="w-[20px] h-[20px]" />
      </button>

      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="w-[80%] max-w-sm rounded-[32px] bg-white p-6">
            <button
              onClick={handleCall}
              className="mb-4 w-full rounded-full bg-primary-blue-500 py-4 text-md text-white"
            >
              Call 1800 123 687
            </button>

            <button
              onClick={handleEmail}
              className="mb-4 w-full rounded-full bg-primary-blue-500 py-4 text-md text-white"
            >
              Email Us
            </button>

            <button
              onClick={() => setOpen(false)}
              className="w-full rounded-full bg-gray-200 py-4 text-md"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </>
  );
}
